import { MenuItem } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import axios from 'axios';
import FileSaver from 'file-saver';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { useGetDocumentDownloadDestinationLazyQueryGQLType } from '../../requests/requests.gql.generated';

type DownloadCreditFacilityDocumentButtonProps = {
  uploadedDocumentId: string;
};

export const DownloadCreditFacilityDocumentButton = ({
  uploadedDocumentId,
}: DownloadCreditFacilityDocumentButtonProps) => {
  const [
    getDocumentDownloadDestination,
  ] = useGetDocumentDownloadDestinationLazyQueryGQLType({});

  const handleDownload = async () => {
    const { data } = await getDocumentDownloadDestination({
      variables: {
        serializedParams: JSON.stringify({
          uploadedDocumentId,
        }),
      },
    });

    finleyAssert(
      data?.downloadUrls,
      `Failed to retrieve valid download URL for implementation document [id: ${uploadedDocumentId}]`,
    );
    finleyAssert(
      data.downloadUrls.length === 1,
      `Expected only one url to be returned for implementation document [id: ${uploadedDocumentId}] download, but received ${data.downloadUrls.length}.`,
    );
    try {
      const response = await axios({
        url: data.downloadUrls[0].url,
        method: 'GET',
        responseType: 'blob',
      });

      const fileBlob = new Blob([response.data], {
        type: response.data.type,
      });

      const fileName = data.downloadUrls[0].filename;
      FileSaver.saveAs(fileBlob, fileName);
    } catch (err) {
      Sentry.captureException(
        `Error when zipping and downloading implementation document [id: ${uploadedDocumentId}]: ${err}`,
      );

      throw new Error(
        `Failed to download implementation document [id: ${uploadedDocumentId}]`,
      );
    }
  };

  return <MenuItem onClick={handleDownload}>Download</MenuItem>;
};
